module.exports = __webpack_public_path__ + "static/img/fz_xe_tb.04b9d9f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_xe_tb.png
// module id = vGX5
// module chunks = 0